import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initAnalytics } from '@/config/analytics';
import { App } from '@/ui/App';
import '@/ui/styles.css';

initAnalytics();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Прелоадер знімається після першого рендера, а не за таймером.
document.getElementById('preloader')?.classList.add('preloader--hidden');
